import { Container, Group, Stack, Text } from "@mantine/core";
import { IconBrandApple, IconBrandGooglePlay } from "@tabler/icons-react";
import { GooglePlayStoreDownloadLink } from "../../lib/data";

export default function Download() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <Container size="md">
        <Stack align="center" gap="xl">
          <img
            src="/icon.png"
            alt="Virel Logo"
            className="w-32 h-32 md:w-40 md:h-40 rounded-3xl"
          />

          <div className="text-center space-y-2 max-w-2xl">
            <h1 className="text-4xl md:text-6xl font-black text-[#10B981] tracking-tight">
              Experience Virel
            </h1>
            <Text size="xl" className="text-slate-600 font-medium">
              Turn your digital actions into real rewards. Join the verified
              participation network today.
            </Text>
          </div>

          <Group justify="center" gap="md" className="w-full mt-8">
            {/* App Store Button */}
            <a
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <div className="flex items-center gap-4 bg-[#10B981] px-8 py-4 rounded-2xl transition-all hover:bg-[#059669] hover:scale-105">
                <IconBrandApple size={36} className="text-white" />
                <div className="flex flex-col items-start">
                  <span className="text-[10px] text-emerald-100 font-bold uppercase tracking-wider">
                    Download on the
                  </span>
                  <span className="text-xl font-bold text-white leading-none">
                    App Store
                  </span>
                </div>
              </div>
            </a>

            {/* Play Store Button */}
            <a
              href={GooglePlayStoreDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <div className="flex items-center gap-4 bg-[#10B981] px-8 py-4 rounded-2xl transition-all hover:bg-[#059669] hover:scale-105">
                <IconBrandGooglePlay size={36} className="text-white" />
                <div className="flex flex-col items-start">
                  <span className="text-[10px] text-emerald-100 font-bold uppercase tracking-wider">
                    Get it on
                  </span>
                  <span className="text-xl font-bold text-white leading-none">
                    Google Play
                  </span>
                </div>
              </div>
            </a>
          </Group>

          <div className="flex flex-col items-center gap-2 mt-12">
            <div className="w-12 h-1.5 bg-[#10B981] rounded-full opacity-20" />
            <Text size="sm" className="text-slate-400 font-semibold ">
              Made with ❤️ for Nigerians 🇳🇬
            </Text>
          </div>
        </Stack>
      </Container>
    </div>
  );
}
